import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('#machine-region-mapping-items-table', () => {
  import('./internal/machine-region-mapping-items-table').then(({ default: Component }) => Component());
});
